var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.357,
    height: 21.357,
    viewBox: "0 0 21.357 21.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Broken_Search",
    "data-name": "Iconly/Broken/Search",
    transform: "translate(-2.759 -2.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(2.759 2.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search-2",
    "data-name": "Search",
    d: "M21.1,19.869l-3.671-3.589h0l-.086-.131a.864.864,0,0,0-1.214,0h0a8.663,8.663,0,0,1-11.233.364A8.2,8.2,0,0,1,3.071,5.671,8.624,8.624,0,0,1,13.832,2.5a8.267,8.267,0,0,1,4.607,10.022.832.832,0,0,0,.194.824.877.877,0,0,0,.827.248.857.857,0,0,0,.633-.576h0A9.968,9.968,0,0,0,14.754,1,10.416,10.416,0,0,0,1.8,4.363,9.884,9.884,0,0,0,3.256,17.384a10.453,10.453,0,0,0,13.386.55l3.25,3.178a.874.874,0,0,0,1.214,0,.837.837,0,0,0,0-1.2h0Z",
    transform: "translate(0)",
    fill: "#fafbfb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.784e48cfe3b4ca4c3f3e8f0cda649968.svg";
export { ForwardRef as ReactComponent };